import arrayValueFactoryFactory from './arrayValueFactoryFactory'
import floatValueFactory from './floatValueFactory'

const floatArrayValueFactory = arrayValueFactoryFactory.create(
  'Float array',
  floatValueFactory
)

export default floatArrayValueFactory
